// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subIndicatorItem--opq9N {
  position: relative;
  font-size: 15px;
  display: flex;
  align-items: center;
  -moz-column-gap: 4px;
       column-gap: 4px;
  row-gap: 0;
}[dir] .subIndicatorItem--opq9N {
  padding: 5px 0 0 0;
}[dir=ltr] .subIndicatorItem--opq9N {
  margin-right: 0;
}[dir=rtl] .subIndicatorItem--opq9N {
  margin-left: 0;
}

.subIndicatorItemSelected--n8A0y {
  font-weight: 700;
}

.subIndicatorItem--opq9N::before {
  content: '';
  position: absolute;
  top: 20px;
  width: 14px;
  height: 0;
}

[dir] .subIndicatorItem--opq9N::before {
  border-top: 2px dashed var(--tree-color, rgba(0, 0, 0, 0.15));
}

[dir=ltr] .subIndicatorItem--opq9N::before {
  left: -14px;
}

[dir=rtl] .subIndicatorItem--opq9N::before {
  right: -14px;
}

.subIndicatorItem--opq9N:last-child::after {
  content: '';
  position: absolute;
  top: 22px;
  bottom: -2px;
  width: 4px;
}

[dir] .subIndicatorItem--opq9N:last-child::after {
  background: var(--tree-mask-bg, #f5f5f5);
}

[dir=ltr] .subIndicatorItem--opq9N:last-child::after {
  left: -14px;
}

[dir=rtl] .subIndicatorItem--opq9N:last-child::after {
  right: -14px;
}

.subjectName--kUvAz {
  color: #000 !important;
  font-family: museo-sans;
  font-size: 15px;
  font-weight: 300;
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

[dir] .subjectName--kUvAz {
  cursor: pointer;
  border: 1px solid #c3c3c3;
  border-radius: 4px;
  padding: 5px 8px;
  background: white;
}

.subSubIndicatorsTree--FT0Kq {
  --tree-color: rgba(0, 0, 0, 0.2);
  --tree-mask-bg: #f5f5f5;
}

[dir=ltr] .subSubIndicatorsTree--FT0Kq {
  border-left: 2px dashed rgba(0, 0, 0, 0.2);
  margin-left: 8px;
  margin-right: 0;
  padding-left: 12px;
}

[dir=rtl] .subSubIndicatorsTree--FT0Kq {
  border-right: 2px dashed rgba(0, 0, 0, 0.2);
  margin-right: 8px;
  margin-left: 0;
  padding-right: 12px;
}

.selected--aclX6 {
  font-weight: 700;
}

[dir] .selected--aclX6 {
  background: rgba(var(--selected_color), 0.25) !important;
  border: 1px solid rgb(var(--selected_color)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/SubSubIndicators/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EAGf,aAAa;EACb,mBAAmB;EACnB,oBAAe;OAAf,eAAe;EACf,UAAU;AACZ,CATA;EAGE,kBAAkB;AAMpB,CATA;EAIE,eAAe;AAKjB,CATA;EAIE,cAAe;AAKjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,SAAS;EACT,WAAW;EACX,SAAS;AAEX;;AARA;EAOE,6DAA6D;AAC/D;;AARA;EAGE,WAAW;AAKb;;AARA;EAGE,YAAW;AAKb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,SAAS;EACT,YAAY;EACZ,UAAU;AAEZ;;AARA;EAOE,wCAAwC;AAC1C;;AARA;EAGE,WAAW;AAKb;;AARA;EAGE,YAAW;AAKb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAEhB,kBAAkB;EAIlB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EAER,OAAO;AACT;;AAfA;EAKE,eAAe;EAEf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAIhB,iBAAiB;AAEnB;;AAEA;EAKE,gCAAgC;EAChC,uBAAuB;AACzB;;AAPA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AAGpB;;AAPA;EACE,2CAA0C;EAC1C,iBAAgB;EAChB,cAAe;EACf,mBAAkB;AAGpB;;AAEA;EACE,gBAAgB;AAGlB;;AAJA;EAEE,wDAAwD;EACxD,uDAAuD;AACzD","sourcesContent":[".subIndicatorItem {\n  position: relative;\n  font-size: 15px;\n  padding: 5px 0 0 0;\n  margin-right: 0;\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n  row-gap: 0;\n}\n\n.subIndicatorItemSelected {\n  font-weight: 700;\n}\n\n.subIndicatorItem::before {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 20px;\n  width: 14px;\n  height: 0;\n  border-top: 2px dashed var(--tree-color, rgba(0, 0, 0, 0.15));\n}\n\n.subIndicatorItem:last-child::after {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 22px;\n  bottom: -2px;\n  width: 4px;\n  background: var(--tree-mask-bg, #f5f5f5);\n}\n\n.subjectName {\n  color: #000 !important;\n  font-family: museo-sans;\n  font-size: 15px;\n  font-weight: 300;\n  cursor: pointer;\n  font-style: italic;\n  border: 1px solid #c3c3c3;\n  border-radius: 4px;\n  padding: 5px 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: white;\n  flex: 1;\n}\n\n.subSubIndicatorsTree {\n  border-left: 2px dashed rgba(0, 0, 0, 0.2);\n  margin-left: 8px;\n  margin-right: 0;\n  padding-left: 12px;\n  --tree-color: rgba(0, 0, 0, 0.2);\n  --tree-mask-bg: #f5f5f5;\n}\n\n.selected {\n  font-weight: 700;\n  background: rgba(var(--selected_color), 0.25) !important;\n  border: 1px solid rgb(var(--selected_color)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subIndicatorItem": `subIndicatorItem--opq9N`,
	"subIndicatorItemSelected": `subIndicatorItemSelected--n8A0y`,
	"subjectName": `subjectName--kUvAz`,
	"subSubIndicatorsTree": `subSubIndicatorsTree--FT0Kq`,
	"selected": `selected--aclX6`
};
export default ___CSS_LOADER_EXPORT___;
